<form (keydown.enter)="writeValue(!form.get('checkbox').value)" [formGroup]="form">
<ng-container *ngIf="disabled">
	<label
		class="checkbox-wrapper"
	>

			<input
				formControlName="checkbox"
				[attr.checked]="checked"
				type="checkbox"
				autocomplete="false"
				class="checkbox"
				disabled
			/>
			<span [ngClass]="{'align-right': align_right}">{{label}}</span>

	</label>
</ng-container>
<ng-container *ngIf="!disabled">
	<label
		class="checkbox-wrapper"
	>
			<input
				formControlName="checkbox"
				[attr.checked]="checked"
				type="checkbox"
				autocomplete="false"
				class="checkbox"
			>
			<span [ngClass]="{'align-right': align_right}">{{label}}</span>

	</label>
</ng-container>
</form>
